const ConstApiUrls = {
  // AUTH_SERVICE_URL: 'http://localhost:9292/api/auth/',
  // TEST_SERVICE_URL: 'http://localhost:9292/api/test/',
  // API_SERVICE_URL: 'http://localhost:9292/api/pointlmj/',
  // API_SERVICE_URL_UMKM: 'http://localhost:9293/api/umkm/'

  AUTH_SERVICE_URL: 'https://rest1-kepoin.landahur.des-green.com/api/auth/',
  TEST_SERVICE_URL: 'https://rest1-kepoin.landahur.des-green.com/api/test/',
  API_SERVICE_URL: 'https://rest1-kepoin.landahur.des-green.com/api/pointlmj/',
  API_SERVICE_URL_UMKM: 'https://rest2-kepoin.landahur.des-green.com/api/umkm/'

};
export default ConstApiUrls;
